import React, { useState, useEffect, useMemo, lazy, Suspense } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
// components
import Page from '../../components/Page';
import GalleryCard from '../../components/GalleryCard';
import Onescope from './Onescope'; 
import Loader from '../../components/loader/Loadmore';

const InfiniteScroll = lazy(() => import('react-infinite-scroll-component'));
const Grid = lazy(() => import('@mui/material/Grid'));
const {ImageList , Stack , Card , ImageListItem} = lazy(() => import('@mui/material'));
const Box = lazy(() => import('@mui/material/Box'));

// ----------------------------------------------------------------------
export default function AllScopes() {
  const [scope, setScope] = useState([]);
  const [page, setPage] = useState (2);
  const [more, sethasMore] = useState(true);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const config = useMemo(() => ({
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${userInfo?.access}`,
    },
  }), [userInfo?.access]);
  
  // -----*-----*------*------*-----*-----*-----*-----*-----*-----
  // a function to get the initial subcategories
  const getScope = async () => {
    try {
      // use the config if the user is logged in
      const response = userInfo ? await axios.get(`${process.env.REACT_APP_API_KEY}/api/v1/scopes/scopes-list/`, config) : await axios.get(`${process.env.REACT_APP_API_KEY}/api/v1/scopes/scopes-list/`);
      // set the subcategories state with the response data
      setScope(response.data.results);
    } catch (error) {
      // handle any errors
      console.error(error);
    }
  };

  // a function to fetch more subcategories
  const fetchSubcat = async () => {
    try {
      // get the next page of subcategories
      const res = await axios.get(`${process.env.REACT_APP_API_KEY}/api/v1/scopes/scopes-list/?page=${page}`);
      // return the response data
      return res.data.results;
    } catch (error) {
      // handle any errors
      console.error(error);
    }
  };

  // a function to fetch data when scrolling
  const fetchData = async () => {
    try {
      // get the new subcategories
      const newScope = await fetchSubcat();
      // append them to the existing subcategories
      setScope([...scope, ...newScope]);
      // check if there are more subcategories to load
      if (newScope.length === 0 || newScope.length < 25) {
        sethasMore(false);
      }
      // increment the page number
      setPage(page + 1);
    } catch (error) {
      // handle any errors
      console.error(error);
    }
  };

  // use effect hook to get the initial subcategories on mount
  useEffect(() => {
    getScope();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page title='all subcategory'>
      <Suspense fallback={<Loader />}>
        <InfiniteScroll
          dataLength={scope.length} // This is important field to render the next data
          next={fetchData}
          hasMore={more}
          loader={<Loader />}
          endMessage={
            ""
          } 
        >
          <Grid container spacing={1} >
            {scope.map((scope) => (
              // use a unique key for each item
              <Grid item key={scope.id}>
                <Onescope  scope={scope} />
              </Grid>
            ))}
          </Grid>
        </InfiniteScroll>
      </Suspense>
    </Page>
  );
}